<template>
  <div class="layout-wrapper" style="background: #f4f7f9; height: 100%">
    <v-container>
      <v-row>
        <v-col md="8" sm="10" offset-md="2" offset-sm="1">
          <v-sheet elevation="3" style="padding: 75px 89px">
            <v-row justify="space-around">
              <div class="logo py-4">
                <img :src="require('../assets/logos/logo-pict-black.svg')" />
                <h2 class="ml-2 login-header">REVELES</h2>
              </div>
            </v-row>
            <div class="terms-services">
              <span>TOS and EULA</span>
            </div>
            <div class="termly-container">
              <h1>END USER LICENSE AGREEMENT</h1>
              <p>
                This END USER LICENSE AGREEMENT (this “Agreement”) is legally binding. Review these terms carefully. By
                clicking “I Accept” or installing or using any software (“Software”) provided by and between SECOND
                SIGHT DATA DISCOVERY, LLC, an Indiana limited liability company with offices located at 509 South
                Woodscrest Drive, Bloomington, IN 47401 (“Licensor”) you (“Licensee”) agree to these terms. If you do
                not agree, then you may not use the Software.
              </p>
              <p>
                This Agreement is effective as of the date you first accepted the terms, downloaded, installed, updated,
                or used the Software, whichever is earliest (the “Effective Date”). This Agreement includes by reference
                additional Payment Terms. This Agreement incorporates by reference other licenses, terms and conditions,
                and other agreements or documents to which Licensee is subject in connection with or arising out of the
                Software (the “User Agreements”), expressly including but not limited to the Reveles Terms of Services
                (the “TOS”), as provided in Section 13.1 below.
              </p>
              <p>
                WHEREAS, Licensor desires to license the Software (as defined below) to Licensee; and <br />WHEREAS,
                Licensee desires to obtain a license to use the Software for its internal business purposes, subject to
                the terms and conditions of this Agreement. <br />NOW, THEREFORE, in consideration of the mutual
                covenants, terms, and conditions set forth herein, and for other good and valuable consideration, the
                receipt and sufficiency of which are hereby acknowledged, the Parties agree as follows:
              </p>
              <ol>
                <li>
                  <strong>Definitions.</strong><br />
                  <strong>"Action"</strong> means any claim, action, cause of action, demand, lawsuit, arbitration,
                  inquiry, audit, notice of violation, proceeding, litigation, citation, summons, subpoena, or
                  investigation of any nature, civil, criminal, administrative, regulatory, or other, whether at law, in
                  equity, or otherwise.<br />
                  <strong>"Affiliate"</strong> of a Person means any other Person that directly or indirectly, through
                  one or more intermediaries, controls, is controlled by, or is under common control with, such Person.
                  The term “control” (including the terms “controlled by” and “under common control with”) means the
                  direct or indirect power to direct or cause the direction of the management and policies of a Person,
                  whether through the ownership of voting securities, by contract, or otherwise.<br />
                  <strong>"Authorized User"</strong> means an employee or Permitted Agent of Licensee.<br />
                  <strong>"Business Day"</strong> means a day other than a Saturday, Sunday, or other day on which
                  commercial banks in Indianapolis, Indiana are authorized or required by Law to be closed for
                  business.<br />
                  <strong>"Confidential Information"</strong> has the meaning set forth in Section 7.1.<br />
                  <strong>"Disclosing Party"</strong> has the meaning set forth in Section 7.1.<br />
                  <strong>"Documentation"</strong> means Licensor’s user manuals, handbooks, and installation guides
                  relating to the Software that Licensor provides or makes available to Licensee in any form or medium
                  that describe the functionality, components, features, or requirements of the Software, including any
                  aspect of the installation, configuration, integration, operation, or use of the Software.<br />
                  <strong>"Effective Date"</strong> has the meaning set forth in the preamble.<br />
                  <strong>"Force Majeure Event"</strong> has the meaning set forth in Section 13.10(a).<br />
                  <strong>"Indemnitee"</strong> has the meaning set forth in Section 10.3.<br />
                  <strong>"Indemnitor"</strong> has the meaning set forth in Section 10.3.<br />
                  <strong>"Intellectual Property Rights"</strong> means any and all registered and unregistered rights
                  granted, applied for, or otherwise now or hereafter in existence under or related to any patent,
                  copyright, trademark, trade secret, database protection, or other intellectual property rights Laws,
                  and all similar or equivalent rights or forms of protection, in any part of the world.<br />
                  <strong>"Law"</strong> means any statute, law, ordinance, regulation, rule, code, order, constitution,
                  treaty, common law, judgment, decree, or other requirement of any federal, state, local, or foreign
                  government or political subdivision thereof, or any arbitrator, court, or tribunal of competent
                  jurisdiction.<br />
                  <strong>"Licensee"</strong> means the individual person, or legal entity on behalf such person acts,
                  that licenses the software and is identified by name during the Software account creation and
                  registration process.<br />
                  <strong>"License Fee"</strong> has the meaning set in the Payment Terms available online, or as
                  otherwise agreed upon in writing between the Parties<br />
                  <strong>"Licensee Indemnitee"</strong> has the meaning set forth in Section 10.1.<br />
                  <strong>"Licensor Indemnitee"</strong> has the meaning set forth in Section 10.2.<br />
                  <strong>"Loss"</strong> or <strong>“Losses"</strong> means all losses, damages, deficiencies, claims,
                  actions, judgments, settlements, interest, awards, penalties, fines, costs, or expenses of whatever
                  kind, including reasonable attorneys’ fees and the costs of enforcing any right to indemnification
                  hereunder and the cost of pursuing any insurance providers.<br />
                  <strong>"Maintenance Release"</strong> means any update, upgrade, release, or other adaptation or
                  modification of the Software, including any updated Documentation, that Licensor may provide to
                  Licensee from time to time during the Term, which may contain, among other things, error corrections,
                  enhancements, improvements, or other changes to the user interface, functionality, compatibility,
                  capabilities, performance, efficiency, or quality of the Software, but does not include any New
                  Version.<br />
                  <strong>"New Version"</strong> means any new version of the Software that Licensor may from time to
                  time introduce and market generally as a distinct licensed product (as may be indicated by Licensor’s
                  designation of a new version number), and which Licensor may make available to Licensee at an
                  additional cost under a separate written agreement.<br />
                  <strong>"Open Source Components"</strong> means any software component that is subject to any open
                  source license agreement, including any software available under the GNU Affero General Public License
                  (AGPL), GNU General Public License (GPL), GNU Lesser General Public License (LGPL), Mozilla Public
                  License (MPL), Apache License, BSD licenses, or any other license that is approved by the Open Source
                  Initiative.<br />
                  <strong>"Open Source License"</strong> has the meaning set forth in Section 2.2.<br />
                  <strong>"Parties"</strong> has the meaning set forth in the preamble.<br />
                  <strong>"Party"</strong> has the meaning set forth in the preamble.<br />
                  <strong>"Permitted Agent"</strong> means a third-party employed by Licensee for the purpose of
                  installing or using the Software.<br />
                  <strong>"Permitted Use"</strong> means use of the Software by an Authorized User for the benefit of
                  Licensee in the ordinary course of its internal business operations. The Permitted Use shall not
                  include the use of the Software to produce data for sale, transfer, or distribution to third parties
                  other than wholly owned subsidiaries of Licensee.<br />
                  <strong>"Person"</strong> means an individual, corporation, partnership, joint venture, limited
                  liability entity, governmental authority, unincorporated organization, trust, association, or other
                  entity.<br />
                  <strong>"Receiving Party"</strong> has the meaning set forth in Section 7.1.<br />
                  <strong>"Reference Data"</strong> has the meaning set forth in Section 2.3.<br />
                  <strong>"Representatives"</strong> means, with respect to a Party, that Party’s employees, officers,
                  directors, consultants, agents, independent contractors, service providers, sublicensees,
                  subcontractors, and legal advisors.<br />
                  <strong>"Software"</strong> has the meaning set forth in the preamble and includes the Reveles data
                  discovery application and related components.<br />
                  <strong>"Term"</strong> has the meaning set forth in Section 12.1.<br />
                  <strong>"Third-Party Materials"</strong> means materials and information, in any form or medium, that
                  are not proprietary to Licensor, including any third-party: (a) documents, data, content or
                  specifications; (b) Open Source Components or other software, hardware or other products, facilities,
                  equipment or devices; and (c) accessories, components, parts or features of any of the foregoing.<br />
                  <strong>"TOS"</strong> has the meaning set forth above.<br />
                  <strong>"User Agreements"</strong> has the meaning set forth above.<br />
                  <strong>"User Agreement List"</strong> means a list of the User Agreements.<br />
                  <strong>"Website"</strong> means http://secondsight.ai.<br />
                </li>
                <li>
                  <strong>License.</strong>
                  <ol>
                    <li>
                      License Grant. Subject to and conditioned on Licensee’s payment of the License Fee and compliance
                      with all other terms and conditions of this Agreement, including compliance with the User
                      Agreements, Licensor hereby grants to Licensee a non-exclusive, non-sublicensable, and
                      non-transferable license to use the Software and Documentation solely for the Permitted Use during
                      the Term. Licensee acknowledges that it is the intent of the Parties that Licensee be an end user
                      of the Software and Documentation. Licensee acquires no ownership of the Software or other
                      Licensor products nor any right to participate in the development, marketing, maintenance, or
                      production of the Software or other Licensor products.
                    </li>
                    <li>
                      Open Source Licenses. The Software may include Open Source Components licensed under the
                      applicable open source licenses governing the use of such Open Source Components (each, an “Open
                      Source License”). Any use of the Open Source Components by Licensee is governed by, and subject
                      to, the terms and conditions of the Open Source License(s).
                    </li>
                    <li>
                      Security Measures; Licensor Access. The Software may contain technological measures designed to
                      prevent unauthorized or illegal use of the Software. Licensee acknowledges and agrees that: (a)
                      Licensor may use these and other lawful measures to verify Licensee’s compliance with the terms of
                      this Agreement and enforce Licensor’s rights, including all Intellectual Property Rights, in and
                      to the Software; (b) Licensor may deny any individual access to and/or use of the Software if
                      Licensor, in its sole discretion, believes that person’s use of the Software would violate any
                      provision of this Agreement, regardless of whether Licensee designated that person as an
                      Authorized User; and (c) Licensor and its Representatives may collect, maintain, process, and use
                      diagnostic, technical, usage and related information, including information about Licensee’s
                      computers, systems and software, and the analytic data produced by the Software as a result of
                      Licensee’s use thereof (provided that such data shall not include Licensee’s Confidential
                      Information, but only the results of the Software’s analysis thereof) (collectively, “Reference
                      Data”).
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>License Restrictions.</strong> Except as this Agreement expressly permits, Licensee shall not,
                  and shall not permit any other Person to:
                  <br />
                  (a) copy the Software, in whole or in part
                  <br />
                  (b) modify, correct, adapt, translate, enhance, or otherwise prepare derivative works or improvements
                  of any Software

                  <br />
                  (c) rent, lease, lend, sell, sublicense, assign, distribute, publish, transfer, or otherwise make
                  available the Software to any third party

                  <br />
                  (d) reverse engineer, disassemble, decompile, decode, or adapt the Software, or otherwise attempt to
                  derive or gain access to the source code of the Software, in whole or in part

                  <br />
                  (e) bypass or breach any security device or protection used for or contained in the Software or
                  Documentation

                  <br />
                  (f) remove, delete, efface, alter, obscure, translate, combine, supplement, or otherwise change any
                  trademarks, terms of the Documentation, warranties, disclaimers, or Intellectual Property Rights,
                  proprietary rights or other symbols, notices, marks, or serial numbers on or relating to any copy of
                  the Software or Documentation

                  <br />
                  (g) use the Software in any manner or for any purpose that infringes, misappropriates, or otherwise
                  violates any Intellectual Property Right or other right of any Person, or that violates any applicable
                  Law

                  <br />
                  (h) use the Software for purposes of: (i) benchmarking or competitive analysis of the Software; (ii)
                  developing, using or providing a competing software product or service; or (iii) any other purpose
                  that is to Licensor’s detriment or commercial disadvantage

                  <br />
                  (i) use the Software in or in connection with the design, construction, maintenance, operation, or use
                  of any hazardous environments, systems, or applications, any safety response systems or other
                  safety-critical applications, or any other use or application in which the use or failure of the
                  Software could lead to personal injury or severe physical or property damage; or

                  <br />
                  (j) use (i) the Software or Documentation other than for the Permitted Use or in any manner or for any
                  purpose or application not expressly permitted by this Agreement or (ii) any Open Source Components in
                  any manner or for any purpose or application not expressly permitted by the controlling Open Source
                  License
                </li>
                <li>
                  <strong>Delivery; Hosting; Use; Data.</strong>
                  <ol>
                    <li>
                      Delivery. Licensor shall deliver one copy of the Software electronically, on tangible media, or by
                      other means, in Licensor’s sole discretion, to Licensee within five (5) Business Days of the
                      Effective Date. Unless separately agreed to in writing, Licensor shall have no obligation to
                      provide any services with respect to the Software, including, without limitation, configuration,
                      installation, or deployment services.
                    </li>
                    <li>
                      Hosting. Elements of the Software licensed to Licensee hereunder shall be hosted on Licensee’s
                      systems, and Licensee shall be solely responsible for providing, operating, and maintaining all
                      equipment, network connections, and other software required to use the Software, at Licensee’s
                      sole cost. Licensee acknowledges that use of the Software may require the retrieval or exchange of
                      tokens from Licensor’s servers from time to time.
                    </li>
                    <li>
                      Use. Licensee acknowledges that the Software is only capable of producing results with respect to
                      data that Licensee elects to scan using the Software. Licensor disclaims any responsibility for
                      Licensee’s failure to effectively utilize the Software, including, without limitation, Licensee’s
                      decisions with respect to the use of the Software on Licensee’s data. In addition, Licensee agrees
                      not to use the Software to upload any of the following, including but not limited to: <br />(a)
                      Disruptive or harmful software such as a virus, worm, or other harmful software or data; and
                      <br />(b) Content that would encourage criminal or civil liability under any local, state,
                      federal, or foreign law.
                    </li>
                    <li>
                      Data. Licensee acknowledges that metadata and data from their network including, files and
                      extracts from applications or databases, will be uploaded to Licensor’s servers. The data uploaded
                      belong to Licensee. Licensee grants Licensor permission to use and store the data for as long as
                      necessary for Licensee’s use of the Software. Licensee is solely responsible for the data uploaded
                      and assumes all risks associated with them, including intellectual property or other legal claims.
                      By uploading the data, you represent that you have the necessary rights to the material, and that
                      doing so does not conflict with the rights of a third party.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Maintenance Releases.</strong> During the Term, Licensor will provide Licensee with all
                  Maintenance Releases (including updated Documentation) that Licensor may, in its sole discretion, make
                  generally available to licensees of the Software, at no additional charge. All Maintenance Releases
                  provided by Licensor to Licensee shall be deemed Software. Licensee will accept and install all
                  Maintenance Releases as soon as practicable after receipt. Licensee does not have any right hereunder
                  to receive any New Versions of the Software that Licensor may, in its sole discretion, release from
                  time to time.
                </li>
                <li>
                  <strong>Fees and Payment.</strong>
                  <ol>
                    <li>
                      License Fees. Licensee shall pay Licensor a periodic License Fee in the manner set forth below.
                    </li>
                    <li>
                      Taxes. All License Fees and other amounts payable by Licensee under this Agreement are exclusive
                      of taxes and similar assessments. Without limiting the foregoing, Licensee is responsible for all
                      sales, use, and excise taxes, and any other similar taxes, duties, and charges of any kind imposed
                      by any federal, state, or local governmental or regulatory authority on any amounts payable by
                      Licensee hereunder, other than any taxes imposed on Licensor’s income.
                    </li>

                    <li>
                      Payment. Licensee shall pay Licensor a License Fee as set forth in the Payment Terms available
                      online, or as otherwise agreed upon by the Parties in writing. Licensee acknowledges that Licensor
                      may modify the License Fee from time to time and that any such change will be noted in the Payment
                      Terms available online. Except as otherwise provided in writing, the License Fee for any
                      subsequent period shall be due and payable not less than thirty (30) days prior to the expiration
                      of the then current Term. All payments hereunder shall be made in US dollars in readily available
                      funds to the address or account specified by Licensor from time to time.
                    </li>

                    <li>
                      Late Payment. If Licensee fails to make any payment when due then, in addition to all other
                      remedies that may be available to Licensor: <br />(a) Licensor may charge interest on the past due
                      amount at the rate of 1.5% per month calculated daily and compounded monthly or, if lower, the
                      highest rate permitted under applicable Law; <br />(b) Licensee shall reimburse Licensor for all
                      costs incurred by Licensor in collecting any late payment of amounts due or related interest,
                      including attorneys’ fees, court costs, and collection agency fees; and <br />(c) if such failure
                      continues for fifteen (15) days following written notice thereof, Licensor may: (i) disable
                      Licensee’s use of the Software (including by means of a disabling code, technology or device);
                      (ii) withhold, suspend or revoke its grant of a license hereunder; (iii) move Licensee to a lower
                      tier of service; and/or (iv) terminate this Agreement under Section 12.2(a).
                    </li>

                    <li>
                      No Deductions or Setoffs. All amounts payable to Licensor under this Agreement shall be paid by
                      Licensee to Licensor in full without any setoff, recoupment, counterclaim, deduction, debit or
                      withholding for any reason (other than any deduction or withholding of tax as may be required by
                      applicable Law).
                    </li>

                    <li>
                      Renewal. Licensee’s License will automatically be renewed unless terminated by either Party under
                      this Agreement.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Confidentiality.</strong>
                  <ol>
                    <li>
                      Confidential Information. In connection with this Agreement, each Party (the “Disclosing Party”)
                      may disclose or make available Confidential Information to the other Party (the “Receiving
                      Party”). Subject to Section 7.2, “Confidential Information” means information in any form or
                      medium (whether oral, written, electronic, or other) that the Disclosing Party considers
                      confidential or proprietary, including information consisting of or relating to the Disclosing
                      Party’s technology, trade secrets, know-how, business operations, plans, strategies, customers,
                      pricing, and information with respect to which the Disclosing Party has contractual or other
                      confidentiality obligations, whether or not marked, designated, or otherwise identified as
                      “confidential.” Without limiting the foregoing, the Software, Documentation, and financial terms
                      and existence of this Agreement are the Confidential Information of Licensor.
                    </li>
                    <li>
                      Exclusions. Confidential Information does not include information that the Receiving Party can
                      demonstrate by written or other documentary records: <br />(a) was rightfully known to the
                      Receiving Party without restriction on use or disclosure prior to such information being disclosed
                      or made available to the Receiving Party in connection with this Agreement; <br />(b) was or
                      becomes generally known by the public other than by the Receiving Party’s or any of its
                      Representatives’ noncompliance with this Agreement; <br />(c) was or is received by the Receiving
                      Party on a non-confidential basis from a third party that was not or is not, at the time of such
                      receipt, under any obligation to maintain its confidentiality; <br />(d) was or is independently
                      developed by the Receiving Party without reference to or use of any Confidential Information.
                      Without limiting the foregoing, the Reference Data shall not be deemed Confidential Information of
                      Licensee.
                    </li>

                    <li>
                      Protection of Confidential Information. As a condition to being provided with any disclosure of or
                      access to Confidential Information, the Receiving Party shall: <br />(a) not access or use
                      Confidential Information other than as necessary to exercise its rights or perform its obligations
                      under and in accordance with this Agreement; <br />(b) except as may be permitted under the terms
                      and conditions of Section 7.4, not disclose or permit access to Confidential Information other
                      than to its Representatives who: (i) need to know such Confidential Information for purposes of
                      the Receiving Party’s exercise of its rights or performance of its obligations under and in
                      accordance with this Agreement; (ii) have been informed of the confidential nature of the
                      Confidential Information and the Receiving Party’s obligations under this Section 7; and (iii) are
                      bound by written confidentiality and restricted use obligations at least as protective of the
                      Confidential Information as the terms set forth in this Section 7; <br />(c) safeguard the
                      Confidential Information from unauthorized use, access or disclosure using at least the degree of
                      care it uses to protect its most sensitive information and in no event less than a reasonable
                      degree of care; <br />(d) promptly notify the Disclosing Party of any unauthorized use or
                      disclosure of Confidential Information and use its best efforts to prevent further unauthorized
                      use or disclosure; and <br />(e) ensure its Representatives’ compliance with, and be responsible
                      and liable for any of its Representatives’ non-compliance with, the terms of this Section 7.
                      Notwithstanding any other provisions of this Agreement, the Receiving Party’s obligations under
                      this Section 7 with respect to any Confidential Information that constitutes a trade secret under
                      any applicable Law will continue until such time, if ever, as such Confidential Information ceases
                      to qualify for trade secret protection under one or more such applicable Laws other than as a
                      result of any act or omission of the Receiving Party or any of its Representatives.
                    </li>
                    <li>
                      Compelled Disclosures. If the Receiving Party or any of its Representatives is compelled by
                      applicable Law to disclose any Confidential Information then, to the extent permitted by
                      applicable Law, the Receiving Party will: <br />(a) promptly, and prior to such disclosure, notify
                      the Disclosing Party in writing of such requirement so that the Disclosing Party can seek a
                      protective order or other remedy or waive its rights under Section 7.3; and <br />(b) provide
                      reasonable assistance to the Disclosing Party in opposing such disclosure or seeking a protective
                      order or other limitations on disclosure. If the Disclosing Party waives compliance or, after
                      providing the notice and assistance required under this Section 7.4, the Receiving Party remains
                      required by Law to disclose any Confidential Information, the Receiving Party will disclose only
                      that portion of the Confidential Information that, on the advice of the Receiving Party’s outside
                      legal counsel, the Receiving Party is legally required to disclose and, on the Disclosing Party’s
                      request, will use commercially reasonable efforts to obtain assurances from the applicable court
                      or other presiding authority that such Confidential Information will be afforded confidential
                      treatment.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Intellectual Property Rights.</strong>
                  <ol>
                    <li>
                      Intellectual Property Ownership. Licensee acknowledges and agrees that: <br />(a) the Software and
                      Documentation are licensed, not sold, to Licensee by Licensor and Licensee does not have under or
                      in connection with this Agreement any ownership interest in the Software or Documentation, or in
                      any related Intellectual Property Rights; and <br />(b) Licensee hereby unconditionally and
                      irrevocably assigns to Licensor its entire right, title and interest in and to any Intellectual
                      Property Rights that Licensee may now or hereafter have in or relating to the Software or
                      Documentation (including any rights in derivative works or patent improvements relating to either
                      of them), whether held or acquired by operation of law, contract, assignment or otherwise.
                    </li>
                    <li>
                      Licensee Cooperation and Notice of Infringement. Licensee shall, during the Term: <br />(a)
                      safeguard the Software and Documentation (including all copies thereof) from infringement,
                      misappropriation, theft, misuse or unauthorized access; <br />(b) at Licensor’s expense, take all
                      such steps as Licensor may reasonably require to assist Licensor in maintaining the validity,
                      enforceability and Licensor’s ownership of the Intellectual Property Rights in the Software and
                      Documentation; <br />(c) promptly notify Licensor in writing if Licensee becomes aware of: (i) any
                      actual or suspected infringement, misappropriation or other violation of Licensor’s Intellectual
                      Property Rights in or relating to the Software or Documentation; or (ii) any claim that the
                      Software or Documentation, including any production, use, marketing, sale or other disposition of
                      the Software or Documentation, in whole or in part, infringes, misappropriates or otherwise
                      violates the Intellectual Property Rights or other rights of any Person; and <br />(d) fully
                      cooperate with and assist Licensor in all reasonable ways in the conduct of any Action by Licensor
                      to prevent or abate any actual or threatened infringement, misappropriation or violation of
                      Licensor’s rights in, and to attempt to resolve any Actions relating to, the Software or
                      Documentation, including having Licensee’s employees testify when requested and making available
                      for discovery or trial relevant records, papers, information, samples, specimens and the like.
                    </li>
                    <li>
                      No Implied Rights. Except for the limited rights and licenses expressly granted under this
                      Agreement, nothing in this Agreement grants, by implication, waiver, estoppel or otherwise, to
                      Licensee or any third party any Intellectual Property Rights or other right, title, or interest in
                      or to any of the Software or Documentation.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Representations and Warranties.</strong>
                  <ol>
                    <li>
                      Mutual Representations and Warranties. Each Party represents, warrants and covenants to the other
                      Party that:
                      <br />
                      (a) it is duly organized, validly existing and in good standing as a limited liability company or
                      other legal entity under the Laws of the jurisdiction of its formation or other organization;
                      <br />

                      (b) it has the full right, power and authority to enter into and perform its obligations and grant
                      the rights, licenses and authorizations it grants and is required to grant under this Agreement;
                      <br />

                      (c) the execution of this Agreement by its representative whose signature is set forth at the end
                      of this Agreement has been duly authorized by all necessary corporate or organizational action of
                      such Party; and
                      <br />

                      (d) when executed and delivered by both Parties, this Agreement will constitute the legal, valid
                      and binding obligation of such Party, enforceable against such Party in accordance with its terms.
                    </li>
                    <li>
                      Licensee Authorization. Licensee represents and warrants that:
                      <br />
                      (a) the person causing Licensee to execute this Agreement has express authority to do so; and
                      <br />
                      (b) if Licensee has employed or otherwise utilized a Permitted Agent to install or use the
                      Software that such Permitted Agent has authority to access Licensee’s data in connection with the
                      use or installation of the Software.
                    </li>

                    <li>
                      DISCLAIMER OF WARRANTIES. ALL LICENSED SOFTWARE, DOCUMENTATION AND OTHER PRODUCTS, INFORMATION,
                      MATERIALS AND SERVICES PROVIDED BY LICENSOR ARE PROVIDED “AS IS.” LICENSOR SPECIFICALLY DISCLAIMS
                      ALL IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND
                      NON-INFRINGEMENT, AND ALL WARRANTIES ARISING FROM COURSE OF DEALING, USAGE, OR TRADE PRACTICE.
                      WITHOUT LIMITING THE FOREGOING, LICENSOR MAKES NO WARRANTY OF ANY KIND THAT THE LICENSED SOFTWARE
                      OR DOCUMENTATION, OR ANY PRODUCTS OR RESULTS OF THE USE THEREOF, WILL MEET LICENSEE’S OR ANY OTHER
                      PERSON’S REQUIREMENTS, OPERATE WITHOUT INTERRUPTION, ACHIEVE ANY INTENDED RESULT, BE COMPATIBLE OR
                      WORK WITH ANY SOFTWARE, SYSTEMS, OR OTHER SERVICES, OR BE SECURE, ACCURATE, COMPLETE, FREE OF
                      HARMFUL CODE OR ERROR FREE. ALL OPEN SOURCE COMPONENTS AND OTHER THIRD-PARTY MATERIALS ARE
                      PROVIDED “AS IS” AND ANY REPRESENTATION OR WARRANTY OF OR CONCERNING ANY OF THEM IS STRICTLY
                      BETWEEN LICENSEE AND THE THIRD-PARTY OWNER OR DISTRIBUTOR OF SUCH OPEN SOURCE COMPONENTS AND
                      THIRD-PARTY MATERIALS.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Indemnification.</strong>
                  <ol>
                    <li>
                      Licensor Indemnification. Licensor shall indemnify, defend, and hold harmless Licensee and
                      Licensee’s officers, directors, employees, agents, permitted successors and permitted assigns
                      (each, a “Licensee Indemnitee”) from and against any and all Losses incurred by the Licensee
                      Indemnitee resulting from any Action by a third party that the Software or Documentation, or any
                      use of the Software or Documentation in accordance with this Agreement, infringes or
                      misappropriates such third party’s US Intellectual Property Rights. This Section 10.1 does not
                      apply to the extent that the alleged infringement arises from:
                      <br />
                      (a) Open Source Components or other Third-Party Materials;
                      <br />

                      (b) combination, operation, or use of the Software in or with, any technology (including any
                      software, hardware, firmware, system or network) or service not provided by Licensor or specified
                      for Licensee’s use in the Documentation;
                      <br />

                      (c) modification of the Software other than: (i) by Licensor in connection with this Agreement; or
                      (ii) with Licensor’s express written authorization and in strict accordance with Licensor’s
                      written directions and specifications;
                      <br />

                      (d) use of any version of the Software other than the most current version or failure to timely
                      implement any Maintenance Release, modification, update or replacement of the Software made
                      available to Licensee by Licensor;
                      <br />

                      (e) use of the Software after Licensor’s notice to Licensee of such activity’s alleged or actual
                      infringement, misappropriation or other violation of a third party’s rights;
                      <br />

                      (f) negligence, abuse, misapplication, or misuse of the Software or Documentation by or on behalf
                      of Licensee, Licensee’s Representatives, or a third party;
                      <br />

                      (g) use of the Software or Documentation by or on behalf of Licensee that is outside the purpose,
                      scope, or manner of use authorized by this Agreement or in any manner contrary to Licensor’s
                      instructions;
                      <br />

                      (h) events or circumstances outside of Licensor’s commercially reasonable control (including any
                      third-party hardware, software, or system bugs, defects, or malfunctions); or
                      <br />

                      (i) Third-Party Claims or Losses for which Licensee is obligated to indemnify Licensor pursuant to
                      Section 10.2.
                    </li>
                    <li>
                      Licensee Indemnification. Licensee shall indemnify, defend, and hold harmless Licensor and its
                      Affiliates, and each of its and their respective officers, directors, employees, agents,
                      subcontractors, permitted successors and permitted assigns (each, a “Licensor Indemnitee”) from
                      and against any and all Losses incurred by the Licensor Indemnitee resulting from any Action by a
                      third party:
                      <br />

                      (a) that any Intellectual Property Rights or other right of any Person, or any Law, is or will be
                      infringed, misappropriated, or otherwise violated by any: (i) use or combination of the Software
                      by or on behalf of Licensee or any of its Representatives with any hardware, software, system,
                      network, service, or other matter whatsoever that is neither provided by Licensor nor authorized
                      by Licensor in this Agreement and the Documentation; and (ii) information, materials, or
                      technology directly or indirectly provided by Licensee or directed by Licensee to be installed,
                      combined, integrated, or used with, as part of, or in connection with the Software or
                      Documentation;
                      <br />

                      (b) relating to facts that, if true, would constitute a breach by Licensee of any representation,
                      warranty, covenant, or obligation under this Agreement;
                      <br />

                      (c) relating to negligence, abuse, misapplication, misuse or more culpable act or omission
                      (including recklessness or willful misconduct) by or on behalf of Licensee or any of its
                      Representatives with respect to the Software or Documentation or otherwise in connection with this
                      Agreement; or
                      <br />

                      (d) relating to use of the Software or Documentation by or on behalf of Licensee or any of its
                      Representatives that is outside the purpose, scope or manner of use authorized by this Agreement
                      or the Documentation, or in any manner contrary to Licensor’s instructions.
                    </li>
                    <li>
                      Indemnification Procedure. Each Party shall promptly notify the other Party in writing of any
                      Action for which such Party believes it is entitled to be indemnified pursuant to Section 10.1 or
                      Section 10.2. The Party seeking indemnification (the “Indemnitee”) shall cooperate with the other
                      Party (the “Indemnitor”) at the Indemnitor’s sole cost and expense. The Indemnitor shall promptly
                      assume control of the defense and investigation of such Action and shall employ counsel reasonably
                      acceptable to the Indemnitee to handle and defend the same, at the Indemnitor’s sole cost and
                      expense. The Indemnitee may participate in and observe the proceedings at its own cost and expense
                      with counsel of its own choosing. The Indemnitor shall not settle any Action without the
                      Indemnitee’s prior written consent, which shall not be unreasonably withheld or delayed. If the
                      Indemnitor fails or refuses to assume control of the defense of such Action, the Indemnitee shall
                      have the right, but no obligation, to defend against such Action, including settling such Action
                      after giving notice to the Indemnitor, in each case in such manner and on such terms as the
                      Indemnitee may deem appropriate. The Indemnitor’s failure to perform any obligations under this
                      Section 10.3 will relieve the Indemnitor of its obligations under this Section 10, except to the
                      extent that the Indemnitor can demonstrate that it has been materially prejudiced as a result of
                      such failure.
                    </li>
                    <li>
                      Mitigation. If the Software, or any part of the Software, is, or in Licensor’s opinion is likely
                      to be, claimed to infringe, misappropriate or otherwise violate any third-party Intellectual
                      Property Right, or if Licensee’s use of the Software is enjoined or threatened to be enjoined,
                      Licensor may, at its option and sole cost and expense:
                      <br />

                      (a) obtain the right for Licensee to continue to use the Software as contemplated by this
                      Agreement;
                      <br />

                      (b) modify or replace the Software, in whole or in part, to seek to make the Software
                      non-infringing, while providing materially equivalent features and functionality, and such
                      modified or replacement software will constitute Software under this Agreement; or
                      <br />

                      (c) if, after Licensor’s exercise of commercially reasonable efforts, none of the remedies set
                      forth in the above Section 10.4(a) or Section 10.4(b) is reasonably available to Licensor,
                      terminate this Agreement, in its entirety or with respect to the affected part or feature of the
                      Software, effective immediately on written notice to Licensee, in which event Licensee shall cease
                      all use of the Software and Documentation immediately on receipt of Licensee’s notice.
                    </li>
                    <li>
                      Sole Remedy. THIS SECTION 10 SETS FORTH LICENSEE’S SOLE REMEDIES AND LICENSOR’S SOLE LIABILITY AND
                      OBLIGATION FOR ANY ACTUAL, THREATENED, OR ALLEGED CLAIMS THAT THE SOFTWARE OR DOCUMENTATION OR ANY
                      SUBJECT MATTER OF THIS AGREEMENT INFRINGES, MISAPPROPRIATES, OR OTHERWISE VIOLATES ANY
                      INTELLECTUAL PROPERTY RIGHTS OF ANY THIRD PARTY.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Limitations of Liability.</strong>
                  <ol>
                    <li>
                      EXCLUSION OF DAMAGES. IN NO EVENT WILL LICENSOR BE LIABLE UNDER OR IN CONNECTION WITH THIS
                      AGREEMENT OR ITS SUBJECT MATTER UNDER ANY LEGAL OR EQUITABLE THEORY, INCLUDING BREACH OF CONTRACT,
                      TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY, AND OTHERWISE, FOR ANY <br />(a) INCREASED COSTS,
                      DIMINUTION IN VALUE OR LOST BUSINESS, PRODUCTION, REVENUES OR PROFITS, <br />(b) LOSS OF GOODWILL
                      OR REPUTATION, <br />(c) USE, INABILITY TO USE, LOSS, INTERRUPTION, DELAY OR RECOVERY OF ANY
                      LICENSED SOFTWARE OR OPEN SOURCE COMPONENTS OR OTHER THIRD-PARTY MATERIALS, <br />(d) LOSS,
                      DAMAGE, CORRUPTION, OR RECOVERY OF DATA, OR BREACH OF DATA OR SYSTEM SECURITY, <br />(e) COST OF
                      REPLACEMENT GOODS OR SERVICES, OR (f) CONSEQUENTIAL, INCIDENTAL, INDIRECT, EXEMPLARY, SPECIAL,
                      ENHANCED, OR PUNITIVE DAMAGES, IN EACH CASE REGARDLESS OF WHETHER SUCH PERSONS WERE ADVISED OF THE
                      POSSIBILITY OF SUCH LOSSES OR DAMAGES OR SUCH LOSSES OR DAMAGES WERE OTHERWISE FORESEEABLE, AND
                      NOTWITHSTANDING THE FAILURE OF ANY AGREED OR OTHER REMEDY OF ITS ESSENTIAL PURPOSE.
                    </li>
                    <li>
                      CAP ON MONETARY LIABILITY. IN NO EVENT WILL THE AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO
                      THIS AGREEMENT, WHETHER ARISING UNDER OR RELATED TO BREACH OF CONTRACT, TORT (INCLUDING
                      NEGLIGENCE), STRICT LIABILITY OR ANY OTHER LEGAL OR EQUITABLE THEORY, EXCEED THE TOTAL AMOUNTS
                      PAID TO LICENSOR UNDER THIS AGREEMENT IN THE TWELVE (12) MONTH PERIOD PRECEDING THE EVENT GIVING
                      RISE TO THE CLAIM. THE FOREGOING LIMITATIONS APPLY EVEN IF ANY REMEDY FAILS OF ITS ESSENTIAL
                      PURPOSE.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Term and Termination.</strong>
                  <ol>
                    <li>
                      Term. The term of this Agreement (the “Term”) shall commence on the Effective Date and continue on
                      a month-to-month basis, or for such other periods of time as Licensee may agree to, unless
                      terminated earlier in accordance with Section 12.2 below or as otherwise expressly permitted under
                      this Agreement; provided, however, that unless either Party delivers written notice to the other
                      Party not less than thirty (30) days prior to the expiration of the then current Term of its
                      desire not to extend the Term, the Term shall be automatically extended for a period equal in
                      duration to the most recent term, subject to the payment by Licensee of the annual License Fee
                      required hereunder.
                    </li>
                    <li>
                      Termination. This Agreement may be terminated at any time:
                      <br />
                      (a) by Licensor, effective on written notice to Licensee, if Licensee fails to pay any amount when
                      due under this Agreement, where such failure continues more than fifteen (15) days after
                      Licensor’s delivery of written notice thereof;
                      <br />

                      (b) by either Party, effective on written notice to the other Party, if the other Party breaches
                      this Agreement and such breach: (i) is incapable of cure; or (ii) being capable of cure, remains
                      uncured thirty (30) days after the non-breaching Party provides the breaching Party with written
                      notice of such breach;
                      <br />

                      (c) by Licensor, effective immediately, if the Licensee: (i) is dissolved or liquidated or takes
                      any corporate action for such purpose; (ii) becomes insolvent or is generally unable to pay its
                      debts as they become due; (iii) becomes the subject of any voluntary or involuntary bankruptcy
                      proceeding under any domestic or foreign bankruptcy or insolvency Law; (iv) makes or seeks to make
                      a general assignment for the benefit of its creditors; (v) applies for, or consents to, the
                      appointment of a trustee, receiver or custodian for a substantial part of its property; or (vi)
                      attempts to assign or transfer this Agreement in a manner prohibited by Section 13.8.
                    </li>
                    <li>
                      Effect of Termination or Expiration. On the expiration or earlier termination of this Agreement
                      all rights, licenses and authorizations granted to Licensee hereunder will immediately terminate
                      and Licensee will (A) immediately cease all use of and other activities with respect to the
                      Software and Documentation; (B) within fifteen (15) days deliver to Licensor, or at Licensor’s
                      written request destroy, and permanently erase from all devices and systems Licensee directly or
                      indirectly controls, the Software, the Documentation and the Licensor’s Confidential Information,
                      including all documents, files, and tangible materials (and any partial and complete copies)
                      containing, reflecting, incorporating, or based on any of the foregoing, whether or not modified
                      or merged into other materials; and (C) certify to Licensor in a signed and notarized written
                      instrument that it has complied with the requirements of this Section 12.3.
                    </li>
                    <li>
                      Surviving Terms. The provisions set forth in the following sections, and any other right,
                      obligation or provision under this Agreement that, by its nature, should survive termination or
                      expiration of this Agreement, will survive any expiration or termination of this Agreement: this
                      Section 12.4, Section 1., Section 3, Section 6, Section 7., Section 8., Section 10, Section 11,
                      and Section 13.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Miscellaneous.</strong>
                  <ol>
                    <li>
                      User Agreements. This Agreement expressly incorporates any other agreements or terms and
                      conditions governing, related to, or arising out of the use of the Software, expressly including
                      the User Agreements, all of which are incorporated into this Agreement by reference. User
                      Agreements may be modified as provided in their terms, with notice also provided in accordance
                      with their terms, including through the use of a pop-up notification on the Software or through
                      the Website.
                    </li>
                    <li>
                      Further Assurances. On a Party’s reasonable request, the other Party shall, at the requesting
                      Party’s sole cost and expense, execute and deliver all such documents and instruments, and take
                      all such further actions, as may be necessary to give full effect to this Agreement.
                    </li>
                    <li>
                      Relationship of the Parties. The relationship between the Parties is that of independent
                      contractors. Nothing contained in this Agreement will be construed as creating any agency,
                      partnership, joint venture, or other form of joint enterprise, employment, or fiduciary
                      relationship between the Parties, and neither Party shall have authority to contract for or bind
                      the other Party in any manner whatsoever.
                    </li>
                    <li>
                      Public Announcements. Neither Party shall issue or release any announcement, statement, press
                      release, or other publicity or marketing materials relating to this Agreement or, unless expressly
                      permitted under this Agreement, otherwise use the other Party’s trademarks, service marks, trade
                      names, logos, domain names, or other indicia of source, association or sponsorship, in each case,
                      without the prior written consent of the other Party, which shall not be unreasonably delayed or
                      withheld, provided, however, that Licensor may, without Licensee’s consent, include Licensee’s
                      name and other indicia in its lists of Licensor’s current or former customers of Licensor in
                      promotional and marketing materials.
                    </li>
                    <li>
                      Notices. Any notice, request, consent, claim, demand, waiver, or other communication under this
                      Agreement have legal effect only if in writing and addressed to a Party as follows (or to such
                      other address or such other person that such addressee Party may designate from time to time in
                      accordance with this Section 13.4):
                      <table>
                        <tr>
                          <td>If to Licensor:</td>
                          <td>
                            Second Sight Data Discovery, LLC <br />
                            509 South Woodscrest Drive <br />
                            Bloomington, IN 47401 <br />Email: legal@secondsight.ai
                          </td>
                        </tr>
                        <td>If to Licensee:</td>
                        <td>
                          [__________________________] <br />Facsimile: [FAX NUMBER] <br />[Email: [EMAIL ADDRESS]]
                          <br />Attention: [NAME AND TITLE OF OFFICER TO RECEIVE NOTICES]
                        </td>
                      </table>
                      Notices sent in accordance with this Section 13.4 will be deemed effectively given: (a) when
                      received, if delivered by hand, with signed confirmation of receipt; (b) when received, if sent by
                      a nationally recognized overnight courier, signature required; (c) when sent, if by facsimile or
                      email (in each case, with confirmation of transmission), if sent during the addressee’s normal
                      business hours, and on the next Business Day, if sent after the addressee’s normal business hours;
                      and (d) on the third (3rd) day after the date mailed by certified or registered mail, return
                      receipt requested, postage prepaid.
                    </li>
                    <li>
                      Interpretation. For purposes of this Agreement: (a) the words “include,” “includes” and
                      “including” are deemed to be followed by the words “without limitation”; (b) the word “or” is not
                      exclusive; (c) the words “herein,” “hereof,” “hereby,” “hereto” and “hereunder” refer to this
                      Agreement as a whole; (d) words denoting the singular have a comparable meaning when used in the
                      plural, and vice versa; and (e) words denoting any gender include all genders. Unless the context
                      otherwise requires, references in this Agreement: (x) to sections, exhibits, schedules,
                      attachments, and appendices mean the sections of, and exhibits, schedules, attachments, and
                      appendices to, this Agreement; (y) to an agreement, instrument or other document means such
                      agreement, instrument or other document as amended, supplemented and modified from time to time to
                      the extent permitted by the provisions thereof; and (z) to a statute means such statute as amended
                      from time to time and includes any successor legislation thereto and any regulations promulgated
                      thereunder. The Parties intend this Agreement to be construed without regard to any presumption or
                      rule requiring construction or interpretation against the Party drafting an instrument or causing
                      any instrument to be drafted. The exhibits, schedules, attachments, and appendices referred to
                      herein are an integral part of this Agreement to the same extent as if they were set forth
                      verbatim herein.
                    </li>
                    <li>
                      Headings. The headings in this Agreement are for reference only and do not affect the
                      interpretation of this Agreement.
                    </li>
                    <li>
                      Entire Agreement. This Agreement constitutes the sole and entire agreement of the Parties with
                      respect to the subject matter of this Agreement and supersedes all prior and contemporaneous
                      understandings, agreements, representations, and warranties, both written and oral, with respect
                      to such subject matter. If any conflict exists between the language of this Agreement and the TOS,
                      this Agreement shall control.
                    </li>
                    <li>
                      Assignment. Licensee shall not assign or otherwise transfer any of its rights, or delegate or
                      otherwise transfer any of its obligations or performance under this Agreement, in each case
                      whether voluntarily, involuntarily, by operation of law, or otherwise, without Licensor’s prior
                      written consent, which may be withheld in the sole and absolute discretion of Licensor. No
                      assignment, delegation, or transfer will relieve Licensee of any of its obligations or performance
                      under this Agreement. Any purported assignment, delegation, or transfer in violation of this
                      Section 13.8 is void. This Agreement is binding on and inures to the benefit of the Parties hereto
                      and their respective successors and permitted assigns.
                    </li>
                    <li>
                      Export Regulation. The Software may be subject to US export control laws, including the US Export
                      Administration Act and its associated regulations. Licensee will not directly or indirectly,
                      export, re-export, or release the Software to, or make the Software accessible from, any country,
                      jurisdiction or Person to which export, re-export, or release is prohibited by applicable Law.
                      Licensee will comply with all applicable Laws and complete all required undertakings (including
                      obtaining any necessary export license or other governmental approval) prior to exporting,
                      re-exporting, releasing, or otherwise making the Software available outside the US.
                    </li>
                    <li>
                      Force Majeure.
                      <br />
                      (a) No Breach or Default. In no event will Licensor be liable or responsible to Licensee, or be
                      deemed to have defaulted under or breached this Agreement, for any failure or delay in fulfilling
                      or performing any term of this Agreement when and to the extent such failure or delay is caused by
                      any circumstances beyond Licensor’s reasonable control (a “Force Majeure Event”), including acts
                      of God, flood, fire, earthquake or explosion, war, terrorism, invasion, riot or other civil
                      unrest, embargoes or blockades in effect on or after the Effective Date, national or regional
                      emergency, strikes, labor stoppages or slowdowns or other industrial disturbances, passage of Law
                      or any action taken by a governmental or public authority, including imposing an export or import
                      restriction, quota, or other restriction or prohibition or any complete or partial government
                      shutdown, or national or regional shortage of adequate power or telecommunications or
                      transportation.
                      <br />
                      (b) Affected Party Obligations. In the event of any failure or delay caused by a Force Majeure
                      Event, Licensor will give prompt written notice to Licensee stating the period of time the
                      occurrence is expected to continue and use commercially reasonable efforts to end the failure or
                      delay and minimize the effects of such Force Majeure Event.
                    </li>
                    <li>
                      No Third-Party Beneficiaries. This Agreement is for the sole benefit of the Parties hereto and
                      their respective successors and permitted assigns and nothing herein, express or implied, is
                      intended to or will confer on any other Person any legal or equitable right, benefit, or remedy of
                      any nature whatsoever under or by reason of this Agreement.
                    </li>
                    <li>
                      Amendment and Modification; Waiver. No amendment to or modification of this Agreement is effective
                      unless it is in writing and signed by each Party. No waiver by any Party of any of the provisions
                      hereof is effective unless explicitly set forth in writing and signed by the Party so waiving.
                      Except as otherwise set forth in this Agreement, no failure to exercise, or delay in exercising,
                      any rights, remedy, power, or privilege arising from this Agreement will operate or be construed
                      as a waiver thereof; nor will any single or partial exercise of any right, remedy, power, or
                      privilege hereunder preclude any other or further exercise thereof or the exercise of any other
                      right, remedy, power, or privilege.
                    </li>
                    <li>
                      Severability. If any provision of this Agreement is invalid, illegal, or unenforceable in any
                      jurisdiction, such invalidity, illegality, or unenforceability will not affect any other term or
                      provision of this Agreement or invalidate or render unenforceable such term or provision in any
                      other jurisdiction. On such determination that any term or other provision is invalid, illegal, or
                      unenforceable, the Parties hereto shall negotiate in good faith to modify this Agreement so as to
                      effect the original intent of the Parties as closely as possible in a mutually acceptable manner
                      in order that the transactions contemplated hereby be consummated as originally contemplated to
                      the greatest extent possible.
                    </li>
                    <li>
                      Governing Law; Arbitration; Submission to Jurisdiction. This Agreement is governed by and
                      construed in accordance with the internal laws of the State of Indiana without giving effect to
                      any choice or conflict of law provision or rule that would require or permit the application of
                      the laws of any jurisdiction other than those of the State of Indiana. Any controversy or claim
                      arising out of or relating to this Agreement, or its breach, shall be settled by arbitration to be
                      held in Indianapolis, Indiana and administered by the American Arbitration Association (“AAA”) in
                      accordance with its Commercial Arbitration Rules. Judgment on the award rendered by the
                      arbitrator(s) may be entered in court having jurisdiction. The Parties intend that this
                      arbitration clause shall be interpreted to the broadest extent permissible under applicable law,
                      expressly including the Federal Arbitration Act (9 U.S.C. ch. 1) (“FAA”), to mandate resolution of
                      disputes through arbitration by the AAA. The Parties further agree that the federal courts of the
                      United States or the courts of the State of Indiana, in each case located in the city of
                      Indianapolis and County of Marion shall have exclusive jurisdiction over the entry of any legal
                      suit, action, or proceeding (a) to enter any award rendered by the AAA, (b) to enforce this
                      arbitration provision, or (c) for matters, if any, arising out of or related to this Agreement
                      that would not be subject to arbitration pursuant to the FAA despite the Parties’ express
                      agreement to arbitrate. Each Party irrevocably submits to the exclusive jurisdiction of such
                      courts. Service of process, summons, notice, or other document by mail to such Party’s address set
                      forth herein will be effective service of process for any suit, action, or other proceeding
                      brought in any such court.
                    </li>
                    <li>
                      Waiver of Jury Trial. Each Party irrevocably and unconditionally waives any right it may have to a
                      trial by jury in respect of any legal action arising out of or relating to this Agreement or the
                      transactions contemplated hereby.
                    </li>
                    <li>
                      Equitable Relief. Licensee acknowledges and agrees that a breach or threatened breach by Licensee
                      of any of its obligations under Section 7, Section 8, or Section 10 of this Agreement would cause
                      Licensor irreparable harm for which monetary damages would not be an adequate remedy and that, in
                      the event of such breach or threatened breach, Licensor will be entitled to equitable relief,
                      including in a restraining order, an injunction, specific performance, and any other relief that
                      may be available from any court of competent jurisdiction, without any requirement to post a bond
                      or other security, or to prove actual damages or that monetary damages are not an adequate remedy.
                      Such remedies are not exclusive and are in addition to all other remedies that may be available at
                      law, in equity, or otherwise.
                    </li>
                    <li>
                      Attorneys’ Fees. In the event that any action, suit, or other legal or administrative proceeding
                      is instituted or commenced by either Party against the other Party arising out of or related to
                      this Agreement, the prevailing Party is entitled to recover its reasonable attorneys’ fees and
                      court costs from the non-prevailing Party.
                    </li>
                  </ol>
                </li>
              </ol>

              <h1 class="pt-5">REVELES TERMS OF SERVICE</h1>
              <p>
                These Reveles Terms of Service (the “Terms”) set forth the agreement between each user (referred to as
                “you” or a “User”) and Second Sight Data Discovery, LLC (“SecondSight”) regarding your use of the
                Reveles software (the “Software”). Please read these Terms carefully as they set out the bases by which
                Second Sight makes its Services (as defined below) available to you as the User, together with any
                Additional Services (as defined below) made available in connection with the Services.
              </p>
              <p>
                Use of the Services may be subject to additional terms and conditions presented by SecondSight, which
                are incorporated into these Terms by reference, expressly including the EULA (as defined below).
              </p>
              <p>
                By using the Software, you agree to these Terms. If you do not agree to these Terms, you must not use
                the Software.
              </p>
              <p>
                THESE TERMS CONTAIN A MANDATORY ARBITRATION PROVISION THAT REQUIRES THE USE OF ARBITRATION TO RESOLVE
                DISPUTES RATHER THAN JURY TRIALS OR ANY OTHER COURT PROCEEDINGS. THIS ARBITRATION PROVISION IS DETAILED
                IN SECTION 15 BELOW.
              </p>
              <ol>
                <li>
                  Definitions.
                  <br />(a). <strong>“Additional Services”</strong> is defined in Section 3 below. <br />(b).
                  <strong>“Additional Services List”</strong> means a list of Additional Services, as approved by
                  SecondSight. <br />(c). <strong>“Cyber Risk”</strong> means risk for events of financial loss,
                  damages, or loss of use of systems or data related to cybersecurity crimes and torts, including from
                  hacking, ransomware attacks, and other similar concerns <br />(d). <strong>“EULA”</strong> means the
                  End User License Agreement providing the license under which you are may use the Software subject to
                  these Terms. <br />(e). <strong>“Payment Terms”</strong> means the payment terms by which the Software
                  and Services are provided, as included in the User Agreements. <br />(f).
                  <strong>“Privacy Policy”</strong> means the most recent effective version of SecondSight’s privacy
                  policy. <br />(g). <strong>“SecondSight”</strong> is defined above. <br />(h).
                  <strong>“Services”</strong> is defined in Section 2 below. <br />(i). <strong>“Software”</strong> is
                  defined above. <br />(j). <strong>“TOS”</strong> is defined above. <br />(k).
                  <strong>“User”</strong> is defined above. <br />(l). <strong>“User Agreements”</strong> mean licenses,
                  terms and conditions, and other agreements or documents to which User is subject in connection with
                  the Software, the Services, or the Additional Services. <br />(m).
                  <strong>“User Agreement List”</strong> means a list of the User Agreements. <br />(n).
                  <strong>“Website”</strong> means http://secondsight.ai.
                </li>
                <li>
                  <strong>Services.</strong> The Software is an AI-driven operation system that may be used for data
                  audit and data valuation, including to analyze Cyber Risk. Provision of the Software, assistance with
                  use of the Software, production of reports related to the results of the use of the Software, and any
                  other services provided by SecondSight, or their agents or approved contractors, are referred to as
                  the “Services.”
                </li>
                <li>
                  <strong>Additional Services.</strong> The Software and the Services may be integrated with, may
                  otherwise interact with, of may be offered for installation in connection with software, applications,
                  and services licensed by third parties, subject to the approval and consent of SecondSight (the
                  “Additional Services”). An Additional Services List is made publicly available through the Website or
                  the Software.
                </li>
                <li>
                  <strong>Incorporated Agreements.</strong> These Terms expressly incorporate the EULA and any other
                  agreements or terms and conditions governing, related to, or arising out of the Services, expressly
                  including the User Agreements. You acknowledge that the EULA was validly executed by the licensee,
                  whether executed by licensee or licensee’s agent, and expressly acknowledge by using the Software
                  that, if the EULA was executed by licensee’s agent, that such agent had actual authority to execute
                  the EULA, which actual authority is ratified. You acknowledge that any User Agreements in addition to
                  the EULA were validly executed by the parties directly or through agents with actual authority. Any
                  Additional Services are subject to those agreements, licenses, and other terms and conditions required
                  by third parties providing or assisting in providing Additional Services or components of the
                  Additional Services. The User Agreements List is expressly incorporated into these Terms. User
                  expressly acknowledges the applicability and validity of all User Agreements included on the User
                  Agreements List. Any User Agreements not included on the User Agreements List shall not be deemed
                  invalid or inapplicable based only on their absence from the User Agreement List.If any conflict
                  exists between these Terms and the EULA, the language of the EULA shall be deemed to control.
                </li>
                <li>
                  <strong>Installation and Updates.</strong> You give permission to SecondSight to install the Software
                  or any updates to the Software, and expressly permit SecondSight to utilize third-parties to install
                  the Software and any updates. You give permission to SecondSight and any third-parties authorized by
                  SecondSight to install any software or applications in addition to Reveles necessary to provide the
                  Services, and to install any software or applications necessary to provide the Additional Services.
                  You give SecondSight and its agents or third-party contractors installing any software or applications
                  necessary in connection with the Additional Services express authority to execute any licenses, terms
                  and conditions, or other agreements required in connection with the installation and use of such
                  software or applications.
                </li>
                <li>
                  <strong>Permission to Access Data.</strong> If you have engaged any third party to install the
                  Software, including but not limited to a managed service provider, you give such installer express
                  authority to grant access to your data for the purpose of using the Software or allowing the
                  performance of the Services or the Additional Services. Such installers otherwise have express
                  permission to execute the User Agreements as provided in Section 4. You further grant SecondSight
                  permission to share your data with any such third party in the scope of operating the Software and
                  providing the Services or Additional Services.
                </li>
                <li>
                  <strong>Permitted Use.</strong> You agree not to use the Software for the purpose of exploiting any
                  Cyber Risk or for any other illegal purpose.
                </li>
                <li>
                  <strong>Privacy Policy.</strong> You acknowledge that you have had the opportunity to review the
                  Privacy Policy, which is available on the Website. You acknowledge and agree that SecondSight is
                  permitted to revise or amend the Privacy Policy without advance notice.
                </li>
                <li>
                  <strong>Payment.</strong> All payments for the Software and Services shall be made as required in
                  accordance with the Payment Terms, which are incorporated into these Terms by reference. SecondSight
                  may terminate your use of the Software, terminate provision of the Services, and seek all other
                  remedies permitted at law for failure to breach of the Payment Terms.
                </li>
                <li>
                  <strong>Customer Support.</strong> Updated customer support contacts are available on the Website.
                </li>
                <li>
                  <strong>Termination of Services.</strong> These Terms will continue to apply to you for as long as you
                  use the Software, as long as you receive the Services, or as long as the User Agreements are in
                  effect. Sections 4, 7, 9, 12, 13, 14, and 15 shall continue to apply following termination.
                </li>
                <li>
                  <strong>Warranties and Disclaimers.</strong> SECONDSIGHT PROVIDES ITS SOFTWARE ON AN “AS IS” BASIS,
                  WITHOUT ANY WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED, OR STATUTORY. SECOND SIGHT DISCLAIMS ANY
                  EXPRESS, IMPLIED, OR STATUTORY WARRANTIES OF QUALITY, MERCHANTABILITY, FITNESS FOR A PARTICULAR
                  PURPOSE, OR NON-INFRINGEMENT. IN ADDITION, SECONDSIGHT MAKES NO REPRESENTATION REGARDING, NOR DOES IT
                  WARRANT OR ASSUME ANY RESPONSIBILITY FOR, ANY THIRD-PARTY APPLICATIONS (OR THE CONTENT THEREOF),
                  DEVICE ON ANY PRODUCT OR SERVICES ADVERTISED, PROMOTED OR OFFERED BY A THIRD PARTY, AND SECONDSIGHT IS
                  NOT RESPONSIBLE FOR ANY TRANSACTIONS BETWEEN THE USER AND ANY THIRD PARTY. NO ADVICE OR INFORMATION
                  WHETHER ORAL OR IN WRITING OBTAINED BY YOU FROM SECONDSIGHT SHALL CREATE ANY WARRANTY ON BEHALF OF
                  SECONDSIGHT. THIS SECTION APPLIES TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW. WITHOUT LIMITING
                  THE FOREGOING, THE USER ACKNOWLEDGES AND UNDERSTANDS THAT THE SOFTWARE ALONE DOES NOT PREVENT OR
                  MITIGATE CYBER RISK, AND THAT ANY SERVICES OR ADDITIONAL SERVICES CANNOT ELIMINATE CYBER RISK.
                </li>
                <li>
                  <strong>Liability Limitation.</strong> In no event will SecondSight, its officers, owners, employees,
                  agents, directors, subsidiaries, affiliates, successors, assigns, suppliers, or licensors be liable
                  for (a) any indirect, special, incidental, punitive, exemplary, or consequential damages; (b) any loss
                  of use, data, business, or profits (whether direct or indirect), in all cases arising out of the use
                  or inability to use the Software or to receive performance of the Services, or (c) any aggregate
                  liability relating to the Software or the Services greater than that amounts paid by user to
                  SecondSight during the twelve months prior to the first claim. Any claim arising under these terms
                  must be commenced by filing a demand for arbitration as detailed in Section 15.
                </li>
                <li>
                  <strong>Indemnification.</strong> You agree to indemnify and hold SecondSight harmless from and
                  against all damages, losses, and expenses of any kind (including reasonable attorney fees and costs)
                  arising out of or related to: (a) your breach of any of these Terms (including the User Agreements as
                  incorporate into these Terms) and (b) any events of financial loss, damages, or loss of use of systems
                  or data related to cybersecurity crimes and torts, including from hacking, ransomware attacks, and
                  other similar concerns.
                </li>
                <li>
                  <strong>Governing Law, Jurisdiction, and Dispute Resolution.</strong> These Terms are governed by and
                  construed in accordance with the internal laws of the State of Indiana without giving effect to any
                  choice or conflict of law provision or rule that would require or permit the application of the laws
                  of any jurisdiction other than those of the State of Indiana. Any controversy or claim arising out of
                  or relating to this Agreement, or its breach, shall be settled by arbitration to be held in
                  Indianapolis, Indiana and administered by the American Arbitration Association (“AAA”) in accordance
                  with its Commercial Arbitration Rules. Judgment on the award rendered by the arbitrator(s) may be
                  entered in court having jurisdiction. This arbitration clause shall be interpreted to the broadest
                  extent permissible under applicable law, expressly including the Federal Arbitration Act (9 U.S.C. ch.
                  1) (“FAA”), to mandate resolution of disputes through arbitration by the AAA. Any legal suit, action,
                  or proceeding arising out of or related to these Terms, the Software, or the Services will be
                  instituted exclusively in the federal courts of the United States or the courts of the State of
                  Indiana, in each case located in the city of Indianapolis and County of Marion, shall have exclusive
                  jurisdiction over the entry of any legal suit, action, or proceeding (a) to enter any award rendered
                  by the AAA, (b) to enforce this arbitration provision, or (c) for matters, if any, arising out of or
                  related to this Agreement that would not be subject to arbitration pursuant to the FAA despite the
                  express agreement to arbitrate. SecondSight and the User each irrevocably submit to the exclusive
                  jurisdiction of such courts in any such suit, action, or proceeding. Service of process, summons,
                  notice, or other document by mail to such party’s address set forth herein will be effective service
                  of process for any suit, action, or other proceeding brought in any such court.
                </li>
                <li>
                  <strong>Revisions.</strong> SecondSight may make changes to these Terms from time to time by notifying
                  you of such changes by any reasonable means, including through the use of a pop-up notification on the
                  Software or through the Website. Any such changes will not apply to any dispute between SecondSight
                  and you arising prior to the date on which the Terms were changed. Your use of the Software or failure
                  to terminate the Services following any changes to these Terms will constitute your acceptance of such
                  changes. The effective date set forth at the top of this document indicates when these Terms were last
                  changed.
                </li>
                <li>
                  <strong>Entire Agreement.</strong> Other than as stated in Section 4. or this Section 17., or as
                  otherwise explicitly agreed upon in writing between you and SecondSight, these Terms constitute all
                  the terms and conditions agreed upon between you and SecondSight, and supersede any prior agreements
                  related to the subject matter of these Terms, whether written or oral. As noted above, the User
                  Agreements are incorporated into these Terms by reference.
                </li>
                <li>
                  <strong>Severability and Waiver.</strong> Unless otherwise stated, should any provision of these Terms
                  be held invalid or unenforceable for any reason or to any extent, the remaining provisions of these
                  Terms will not be affected, and the application of that provision shall be enforced to the extent
                  permitted by law.
                </li>
                <li>
                  <strong>Assignment.</strong> SecondSight may assign any or all of these Terms, and may assign or
                  delegate, in whole or in part, any of the rights or obligations under these Terms. You may not assign
                  these Terms, in whole or in part, nor transfer or sub-license your rights under these Terms, to any
                  third party.
                </li>
                <li>
                  <strong>Notice and Contact Details.</strong> Any party who intends to seek arbitration must first send
                  a written notice of the dispute to the other party. Any demand to User may be made through the
                  business address provided for SecondSight’s records. Any User demand to SecondSight shall be provided
                  to Second Sight Data Discovery, LLC, Attn: General Counsel, 509 S. Woodscrest Dr., Bloomington, IN
                  47401. The notice must (1) describe the nature and basis of the claim or dispute; and (2) set forth a
                  demand of the specific relief sought. The parties agree to use good faith efforts to resolve the claim
                  directly, but may file an arbitration demand in accordance with Section 15 if a resolution is not
                  reached between the parties within 30 days of notice.
                </li>
              </ol>
              <div class="last-revised">Last Revised: October, 2021</div>
            </div>
            <div class="d-flex flex-row justify-end mt-4">
              <v-btn
                style="width: 120px"
                depressed
                @click="handleSubmit"
                color="#4C86FD"
                class="save-btn mt-4 mb-0"
                tile
              >
                Agree
              </v-btn>
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Eula',
  data () {
    return {
      eula: false
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  mounted () {
    // Inject termly-embed SDK
    const tjs = document.getElementsByTagName('script')[0]
    if (document.getElementById('termly-jssdk')) {
      return
    }
    const js = document.createElement('script')
    js.id = 'termly-jssdk'
    js.src = 'https://app.termly.io/embed-policy.min.js'
    tjs.parentNode.insertBefore(js, tjs)
  },
  methods: {
    handleSubmit () {
      const userData = {
        entity_id: this.user.entity_id,
        user_id: this.user.user_id,
        affiliate_id: this.user.affiliate_id,
        email: this.user.email,
        email_verified: this.user.email_verified,
        nickname: this.user.nickname,
        blocked: false,
        name: this.user.name,
        picture: this.user.picture,
        eula_accepted: true,
        tour_complete: !!this.user?.tour_complete
      }
      this.$store.dispatch('updateProfile', { data: userData, shouldReload: false })

      this.$store.dispatch('setEula')
      this.$router.push('/dashboard')
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
}
.terms-services {
  color: #212338;
  font-family: 'gt_america_extended';
  font-size: 20px;
  letter-spacing: 0;
  line-height: 25px;
  padding: 50px 0px 25px 0px;
  font-weight: bold;
}
.termly-container {
  height: 200px;
  overflow: auto;
  scrollbar-color: #e8e8ea;
  padding: 10px;
  border: 1px solid #9e9e9e;
  color: #212338;
  font-size: 12px;
  h1 {
    font-size: 24px;
    text-align: center;
    padding-bottom: 10px;
  }
  p {
    strong {
      padding-bottom: 5px;
    }
  }
  ol {
    counter-reset: item;
  }
  ol li {
    display: block;
    position: relative;
    .schedule {
      text-align: center;
    }
  }
  ol li:before {
    content: counters(item, '.') '.';
    counter-increment: item;
    position: absolute;
    margin-right: 100%;
    right: 10px; /* space between number and text */
  }
  table {
    border-collapse: collapse;
    width: 100%;
  }

  td {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }

  tr:nth-child(even) {
    background-color: #dddddd;
  }
  .last-revised {
    padding: 10px 0px;
    text-align: right;
  }
}
</style>
